import * as React from "react";
import {useEffect} from "react";
import {Splitter} from "../../../../../util/table-splitter-ui/src/components/Splitters/Splitter";
import {Button, ButtonGroup, Dropdown, Icon, Input, Label} from "semantic-ui-react";
import {RelativeTimeReference, TimeOffset} from "../../../../../../generated/api";
import {enumToDropdownItemProps, sleep} from "../../../../../../utils";
import {authentication} from "../../../../../../authentication";
import {backend} from "../../../../../../xconvert-backend";
import {focusesOnField} from "../newNavTree/NavTree";
import {workingConfig} from "../../ConfigSignal";
import {formatDate} from "../../../../../../format";
import {v4 as uuid} from 'uuid';

export interface ReportTimeBuilderProps {

}

export function ReportTimeBuilder(props: React.PropsWithChildren<ReportTimeBuilderProps>) {

    const [path, setPath] = React.useState<string>()

    const [selectedBaseFrom, setSelectedBaseFrom] = React.useState<RelativeTimeReference.BaseEnum>()
    const [offsetsFrom, setOffsetsFrom] = React.useState<TimeOffset[]>([])
    const [selectedBaseTo, setSelectedBaseTo] = React.useState<RelativeTimeReference.BaseEnum>()
    const [offsetsTo, setOffsetsTo] = React.useState<TimeOffset[]>([])

    const [loading, setLoading] = React.useState(false)
    const [previewFrom, setPreviewFrom] = React.useState<Date>()
    const [previewTo, setPreviewTo] = React.useState<Date>()

    useEffect(() => {
        setPath(getPathOfReportTimeReference())
        loadFromConfig()
    }, [])

    function loadFromConfig() {
        let path = getPathOfReportTimeReference()
        let jp = require('jsonpath')
        let timeReference = jp.value(JSON.parse(workingConfig.value), path)
        setSelectedBaseFrom(timeReference?.from?.base ?? RelativeTimeReference.BaseEnum.NOW)
        setSelectedBaseTo(timeReference?.to?.base ?? RelativeTimeReference.BaseEnum.NOW)
        setOffsetsFrom(timeReference?.from?.offsets ?? [])
        setOffsetsTo(timeReference?.to?.offsets ?? [])

    }

    async function getPreview() {
        setLoading(true)
        let auth = backend.withTokenAuthHeader(authentication.token)

        let response = await backend.internalApi.previewReportTimeReference({
            from: {
                base: selectedBaseFrom,
                offsets: offsetsFrom
            },
            to: {
                base: selectedBaseTo,
                offsets: offsetsTo
            }
        }, auth)

        if (response) {
            setPreviewFrom(response.from)
            setPreviewTo(response.to)
        }
        setLoading(false)
    }

    function save() {
        console.log("save")
        // get path to reportTimeReference
        let path = getPathOfReportTimeReference()
        let jp = require('jsonpath')
        let config = JSON.parse(workingConfig.value)
        jp.value(config, path, {
            from: {
                base: selectedBaseFrom,
                offsets: offsetsFrom
            },
            to: {
                base: selectedBaseTo,
                offsets: offsetsTo
            }
        })
        workingConfig.value = JSON.stringify(config, null, 4)

    }

    function getPathOfReportTimeReference() {
        if (focusesOnField.value?.path?.includes("timeReference")) {
            return focusesOnField.value?.path?.split(".timeReference")[0] + ".timeReference"
        }
        return path
    }

    function singleTimeEditor(from: boolean = true) {
        let value = from ? selectedBaseFrom : selectedBaseTo
        return <div>
            <Dropdown
                style={{width: "240px"}}
                placeholder={"Select a base"}
                clearable
                options={enumToDropdownItemProps(RelativeTimeReference.BaseEnum)}
                selection
                value={value}
                onChange={(evt, data) => {
                    // @ts-ignore
                    let result = evt.target.textContent
                    if (from) {
                        setSelectedBaseFrom(result)
                    } else {
                        setSelectedBaseTo(result)
                    }
                }
                }/>
        </div>
    }

    function listOfOffsets(from: boolean = true) {

        let offsets = from ? offsetsFrom : offsetsTo

        let offsetEditors = offsets?.map((offset, index) => {
            return <Offset
                index={index}
                initialUnit={offset.unit}
                initialDirection={offset.offsetDirection}
                initialValue={offset.value}
                onChange={(offset) => {
                    offsets[index] = offset
                    if (from) {
                        setOffsetsFrom([...offsets])
                    } else {
                        setOffsetsTo([...offsets])
                    }
                }}
                remove={async () => {
                    setLoading(true)
                    console.log("Removing offset at index:", index);
                    console.log("Offsets before removal:", offsets);
                    await sleep(10)
                    let newOffsets = offsets.filter((_, i) => i !== index)
                    console.log("Offsets after removal:", newOffsets);
                    if (from) {
                        setOffsetsFrom(newOffsets)
                    } else {
                        setOffsetsTo(newOffsets)
                    }
                    setLoading(false)
                }}
            />
        })

        return <div>
            {offsetEditors}
            <Button onClick={() => {
                if (from) {
                    setOffsetsFrom([...offsetsFrom, {
                        unit: TimeOffset.UnitEnum.HOURS,
                        offsetDirection: TimeOffset.OffsetDirectionEnum.ADD,
                        value: 0
                    } as TimeOffset])
                } else {
                    setOffsetsTo([...offsetsTo, {
                        unit: TimeOffset.UnitEnum.HOURS,
                        offsetDirection: TimeOffset.OffsetDirectionEnum.ADD,
                        value: 0
                    } as TimeOffset])
                }
            }}>Add offset</Button>
        </div>
    }

    function editor() {
        if(loading) {
            return <p>Loading...</p>
        }
        return <div
            style={{
                padding: "10px",
                overflow: "auto"
            }}>
            <h4>Path: {getPathOfReportTimeReference()}</h4>
            <div style={{border: "1px solid black", padding: "10px"}}>
                <h4>From</h4>
                {singleTimeEditor(true)}
                {listOfOffsets(true)}
            </div>
            <div style={{border: "1px solid black", padding: "10px"}}>
                <h4>To</h4>
                {singleTimeEditor(false)}
                {listOfOffsets(false)}
            </div>
        </div>
    }

    function preview() {
        return <div style={{
            padding: "10px",
            overflow: "auto"
        }}>
            <h1>Preview</h1>
            <ButtonGroup>
                <Button
                    icon={"refresh"}
                    onClick={() => {
                        console.log("refresh")
                        getPreview()
                    }}
                    loading={loading}
                />
                <Button
                    icon={"save"}
                    onClick={() => {
                        console.log("save")
                        save()
                    }}
                    disabled={loading}
                    loading={loading}
                />
            </ButtonGroup>
            <div
                style={{
                    flexDirection: "row",
                    display: "flex",
                }}
            >
                <Label pointing={"right"}>From</Label>
                <p style={{fontSize: 16}}>{formatDate(previewFrom)}</p>
            </div>
            <div
                style={{
                    flexDirection: "row",
                    display: "flex",
                }}
            >
                <Label pointing={"right"}>To</Label>
                <p style={{fontSize: 16}}>{formatDate(previewTo)}</p>
            </div>


        </div>
    }

    return <Splitter
        name="reportTimeBuilder"
        left={editor()}
        right={preview()}
    />
}

interface OffsetProps {
    index?: number
    initialUnit?: TimeOffset.UnitEnum
    initialDirection?: TimeOffset.OffsetDirectionEnum
    initialValue?: number
    onChange?: (offset: TimeOffset) => void
    remove?: () => void
}

function Offset(props: React.PropsWithChildren<OffsetProps>) {

    const [unit, setUnit] = React.useState<TimeOffset.UnitEnum>()
    const [direction, setDirection] = React.useState<TimeOffset.OffsetDirectionEnum>()
    const [value, setValue] = React.useState<number>()

    useEffect(() => {
        setUnit(props.initialUnit)
        setDirection(props.initialDirection)
        setValue(props.initialValue)
    }, [])

    useEffect(() => {
        if (props.onChange) {
            props.onChange({
                unit: unit,
                offsetDirection: direction,
                value: value
            } as TimeOffset)
        }
    }, [unit, direction, value])

    function unitSelector() {
        return <div>
            <Dropdown
                style={{width: "240px"}}
                placeholder={"Select a unit"}
                clearable
                options={enumToDropdownItemProps(TimeOffset.UnitEnum)}
                selection
                value={unit}
                onChange={(evt, _) => {
                    // @ts-ignore
                    setUnit(evt.target.textContent)
                }}
            />
        </div>
    }

    function offsetDirectionSelector() {
        return <div>
            <Dropdown
                style={{width: "240px"}}
                placeholder={"Select a direction"}
                clearable
                options={enumToDropdownItemProps(TimeOffset.OffsetDirectionEnum)}
                selection
                value={direction}
                onChange={(evt, _) => {
                    // @ts-ignore
                    setDirection(evt.target.textContent)
                }}
            />
        </div>
    }

    function offsetEditor() {
        return <div
            key={props.index + uuid()}
            style={{border: "1px solid black", padding: "10px"}}
        >
            <div style={{
                flexDirection: "row",
                display: "flex",
                justifyContent: "space-between"
            }}>
                <h4>Offset {props.index}</h4>
                <Icon
                    name={"trash"}
                    color={"red"}
                    onClick={() => {
                        if (props.remove) {
                            props.remove()
                        }
                    }}
                    style={{
                        float: "right"
                    }}
                />

            </div>
            {unitSelector()}
            {offsetDirectionSelector()}
            <Input
                type={"number"}
                placeholder={"Enter a value"}
                value={value}
                onChange={(evt, data) => {
                    setValue(data.value as unknown as number)
                }}
            />
        </div>
    }

    return offsetEditor()
}